import { useLectureMaterials } from "../hooks/useLectureMaterials";
import { useParams, useSearchParams } from "react-router-dom";
import MaterialItem from "./MaterialItem";
import Pagination from "@/components/Pagination";

function MaterialList() {
    const [searchParams, setSearchParams] = useSearchParams();

    const page = searchParams.get("page")
        ? parseInt(searchParams.get("page"), 10) < 1
            ? 1
            : parseInt(searchParams.get("page"), 10)
        : 1;
    const { courseId, lectureId } = useParams();

    const { isPending, lectureMaterials } = useLectureMaterials({
        courseId,
        lectureId,
        apiOperations: { page, perPage: 5 },
    });

    const totalPages = Math.ceil(
        lectureMaterials?.meta?.total / lectureMaterials?.meta?.per_page
    );

    return (
        <aside className="w-full xl:w-fit">
            <div className="w-full px-4 rounded-lg bg-background-color py-7">
                <h3 className="mb-4 text-2xl text-secondary-color">
                    ماتيريال{" "}
                    <span className="text-secondary-color">المحاضره </span>
                </h3>
                {!isPending && (
                    <div className="w-full xl:w-[420px] min-h-[100px]">
                        {lectureMaterials?.data?.length ? (
                            <ul className="space-y-7">
                                {lectureMaterials?.data?.map((item) => {
                                    return (
                                        <MaterialItem
                                            key={item.id}
                                            id={item.id}
                                            itemData={item.attributes}
                                        />
                                    );
                                })}
                            </ul>
                        ) : (
                            <p className="mt-10 text-lg font-semibold text-center text-gray-color-primary">
                                لا يوجد ملفات مرفقة لهذه المحاضره
                            </p>
                        )}
                        <div className="flex justify-center w-full">
                            {!isPending && totalPages > 1 ? (
                                <Pagination
                                    setSearchParams={setSearchParams}
                                    page={page}
                                    total={totalPages}
                                    className="mt-5"
                                    paginationKey="page"
                                />
                            ) : (
                                ""
                            )}
                        </div>
                    </div>
                )}
            </div>
        </aside>
    );
}

export default MaterialList;
